module.exports = __webpack_public_path__ + "img/Rectangle 85.0d77c41f.png";